import { render, staticRenderFns } from "./DashboardTopUsers.vue?vue&type=template&id=72888f33&"
import script from "./DashboardTopUsers.vue?vue&type=script&lang=js&"
export * from "./DashboardTopUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports